import React from 'react';
import PropTypes from 'prop-types';

const Email = ({ size, className }) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="none"
    viewBox="0 0 72 72"
  >
    <rect width="72" height="72" fill="#E6F3FD" rx="36"></rect>
    <path
      fill="#008AEA"
      d="M50 27c0-1.65-1.35-3-3-3H25c-1.65 0-3 1.35-3 3v18c0 1.65 1.35 3 3 3h22c1.65 0 3-1.35 3-3V27zm-3 0L36 33.5 25 27h22zm0 18H25V30l11 6.5L47 30v15z"
    ></path>
  </svg>
);

Email.propTypes = {
  size: PropTypes.number,
  className: PropTypes.string,
};

Email.defaultProps = {
  size: 72,
  className: '',
};

export default Email;
